"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateInquiryResponse = exports.CreateInquiryResponse = exports.GetInquiryResponse = void 0;
class GetInquiryResponse {
}
exports.GetInquiryResponse = GetInquiryResponse;
class CreateInquiryResponse {
}
exports.CreateInquiryResponse = CreateInquiryResponse;
class UpdateInquiryResponse {
}
exports.UpdateInquiryResponse = UpdateInquiryResponse;
//# sourceMappingURL=inquiry.js.map